import { render, staticRenderFns } from "./EndorsementApplication.vue?vue&type=template&id=f1b67d60&scoped=true"
import script from "./EndorsementApplication.vue?vue&type=script&lang=js"
export * from "./EndorsementApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b67d60",
  null
  
)

export default component.exports